import { get, post } from './axios.js'

/**
 * quota 조회 - /quota/quotaSelect
 * @param {Object} params
 * @property {string} params.fiscal_year - 회계년도
 * @property {string} params.sales_ceo - 영업대표
 * @returns
 */
export async function quotaSelect(params = {}) {
  try {
    const result = await post('/quota/quotaSelect', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * quota 저장,수정 - /quota/quotaEdit
 * @param {Object} params
 * @property {Arry} params.quotaVOList - 저장 및 수정 quota 데이터 List
 * @property {string} params.fiscal_year - 회계년도
 * @property {string} params.sales_ceo - 영업대표
 * @returns
 */
export async function quotaEdit(params = {}) {
    try {
      const result = await post('/quota/quotaEdit', params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}


/**
 * quota 일괄 등록 - /quota/quotaUpload
 * @param {Object} params
 * @property {Array} params.quotaVOList - 저장 및 수정 quota 데이터 List
 * @property {string} params.fiscal_year - 회계년도
 * @property {string} params.sales_ceo - 영업대표
 * @returns
 */
export async function quotaUpload(params = {}) {
    try {
      const result = await post('/quota/quotaUpload', params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}
